export enum EmailDomainStatus {
  PENDING = 'PENDING',
  VERIFYING = 'VERIFYING',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED',
}

export enum EmailDomainProvider {
  SES = 'SES',
}

export enum EmailDomainDnsRecordType {
  TXT = 'TXT',
  MX = 'MX',
  CNAME = 'CNAME',
}
